function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 13.6985,
  y: 21.7705,
  width: 4.57479,
  height: 8.36222,
  rx: 0.25,
  fill: "#5B363A"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 13.6985,
  y: 21.7705,
  width: 4.57479,
  height: 8.36222,
  rx: 0.25,
  fill: "url(#paint0_linear_28327_7673)"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 13.6985,
  y: 21.7705,
  width: 4.57479,
  height: 8.36222,
  rx: 0.25,
  fill: "url(#paint1_linear_28327_7673)"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 13.6985,
  y: 21.7705,
  width: 4.57479,
  height: 8.36222,
  rx: 0.25,
  fill: "url(#paint2_linear_28327_7673)"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 13.6985,
  y: 21.7705,
  width: 4.57479,
  height: 8.36222,
  rx: 0.25,
  fill: "url(#paint3_linear_28327_7673)"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 13.6985,
  y: 21.7705,
  width: 4.57479,
  height: 8.36222,
  rx: 0.25,
  fill: "url(#paint4_radial_28327_7673)"
});

var _ref8 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_i_28327_7673)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.2192 7.32684C21.1263 7.31768 21.0549 7.23909 21.0549 7.14578V7.14578C21.0549 4.34187 18.7819 2.06885 15.978 2.06885C13.174 2.06885 10.901 4.34187 10.901 7.14578V7.14578C10.901 7.23975 10.8292 7.319 10.7357 7.32854C8.07749 7.59955 6.0033 9.84495 6.0033 12.5748C6.0033 13.3904 6.18848 14.1628 6.51904 14.8522C6.60562 15.0327 6.56027 15.2512 6.40884 15.3822C5.28693 16.3531 4.57715 17.7874 4.57715 19.3876C4.57715 22.3118 6.94775 24.6824 9.87201 24.6824H22.0997C25.024 24.6824 27.3946 22.3118 27.3946 19.3876C27.3946 17.7874 26.6848 16.3531 25.5629 15.3822C25.4115 15.2512 25.3662 15.0327 25.4528 14.8522C25.7833 14.1628 25.9684 13.3904 25.9684 12.5748C25.9684 9.83918 23.8856 7.59005 21.2192 7.32684Z",
  fill: "url(#paint5_radial_28327_7673)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.2192 7.32684C21.1263 7.31768 21.0549 7.23909 21.0549 7.14578V7.14578C21.0549 4.34187 18.7819 2.06885 15.978 2.06885C13.174 2.06885 10.901 4.34187 10.901 7.14578V7.14578C10.901 7.23975 10.8292 7.319 10.7357 7.32854C8.07749 7.59955 6.0033 9.84495 6.0033 12.5748C6.0033 13.3904 6.18848 14.1628 6.51904 14.8522C6.60562 15.0327 6.56027 15.2512 6.40884 15.3822C5.28693 16.3531 4.57715 17.7874 4.57715 19.3876C4.57715 22.3118 6.94775 24.6824 9.87201 24.6824H22.0997C25.024 24.6824 27.3946 22.3118 27.3946 19.3876C27.3946 17.7874 26.6848 16.3531 25.5629 15.3822C25.4115 15.2512 25.3662 15.0327 25.4528 14.8522C25.7833 14.1628 25.9684 13.3904 25.9684 12.5748C25.9684 9.83918 23.8856 7.59005 21.2192 7.32684Z",
  fill: "url(#paint6_radial_28327_7673)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.2192 7.32684C21.1263 7.31768 21.0549 7.23909 21.0549 7.14578V7.14578C21.0549 4.34187 18.7819 2.06885 15.978 2.06885C13.174 2.06885 10.901 4.34187 10.901 7.14578V7.14578C10.901 7.23975 10.8292 7.319 10.7357 7.32854C8.07749 7.59955 6.0033 9.84495 6.0033 12.5748C6.0033 13.3904 6.18848 14.1628 6.51904 14.8522C6.60562 15.0327 6.56027 15.2512 6.40884 15.3822C5.28693 16.3531 4.57715 17.7874 4.57715 19.3876C4.57715 22.3118 6.94775 24.6824 9.87201 24.6824H22.0997C25.024 24.6824 27.3946 22.3118 27.3946 19.3876C27.3946 17.7874 26.6848 16.3531 25.5629 15.3822C25.4115 15.2512 25.3662 15.0327 25.4528 14.8522C25.7833 14.1628 25.9684 13.3904 25.9684 12.5748C25.9684 9.83918 23.8856 7.59005 21.2192 7.32684Z",
  fill: "url(#paint7_radial_28327_7673)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.2192 7.32684C21.1263 7.31768 21.0549 7.23909 21.0549 7.14578V7.14578C21.0549 4.34187 18.7819 2.06885 15.978 2.06885C13.174 2.06885 10.901 4.34187 10.901 7.14578V7.14578C10.901 7.23975 10.8292 7.319 10.7357 7.32854C8.07749 7.59955 6.0033 9.84495 6.0033 12.5748C6.0033 13.3904 6.18848 14.1628 6.51904 14.8522C6.60562 15.0327 6.56027 15.2512 6.40884 15.3822C5.28693 16.3531 4.57715 17.7874 4.57715 19.3876C4.57715 22.3118 6.94775 24.6824 9.87201 24.6824H22.0997C25.024 24.6824 27.3946 22.3118 27.3946 19.3876C27.3946 17.7874 26.6848 16.3531 25.5629 15.3822C25.4115 15.2512 25.3662 15.0327 25.4528 14.8522C25.7833 14.1628 25.9684 13.3904 25.9684 12.5748C25.9684 9.83918 23.8856 7.59005 21.2192 7.32684Z",
  fill: "url(#paint8_radial_28327_7673)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.2192 7.32684C21.1263 7.31768 21.0549 7.23909 21.0549 7.14578V7.14578C21.0549 4.34187 18.7819 2.06885 15.978 2.06885C13.174 2.06885 10.901 4.34187 10.901 7.14578V7.14578C10.901 7.23975 10.8292 7.319 10.7357 7.32854C8.07749 7.59955 6.0033 9.84495 6.0033 12.5748C6.0033 13.3904 6.18848 14.1628 6.51904 14.8522C6.60562 15.0327 6.56027 15.2512 6.40884 15.3822C5.28693 16.3531 4.57715 17.7874 4.57715 19.3876C4.57715 22.3118 6.94775 24.6824 9.87201 24.6824H22.0997C25.024 24.6824 27.3946 22.3118 27.3946 19.3876C27.3946 17.7874 26.6848 16.3531 25.5629 15.3822C25.4115 15.2512 25.3662 15.0327 25.4528 14.8522C25.7833 14.1628 25.9684 13.3904 25.9684 12.5748C25.9684 9.83918 23.8856 7.59005 21.2192 7.32684Z",
  fill: "url(#paint9_radial_28327_7673)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.2192 7.32684C21.1263 7.31768 21.0549 7.23909 21.0549 7.14578V7.14578C21.0549 4.34187 18.7819 2.06885 15.978 2.06885C13.174 2.06885 10.901 4.34187 10.901 7.14578V7.14578C10.901 7.23975 10.8292 7.319 10.7357 7.32854C8.07749 7.59955 6.0033 9.84495 6.0033 12.5748C6.0033 13.3904 6.18848 14.1628 6.51904 14.8522C6.60562 15.0327 6.56027 15.2512 6.40884 15.3822C5.28693 16.3531 4.57715 17.7874 4.57715 19.3876C4.57715 22.3118 6.94775 24.6824 9.87201 24.6824H22.0997C25.024 24.6824 27.3946 22.3118 27.3946 19.3876C27.3946 17.7874 26.6848 16.3531 25.5629 15.3822C25.4115 15.2512 25.3662 15.0327 25.4528 14.8522C25.7833 14.1628 25.9684 13.3904 25.9684 12.5748C25.9684 9.83918 23.8856 7.59005 21.2192 7.32684Z",
  fill: "url(#paint10_radial_28327_7673)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.2192 7.32684C21.1263 7.31768 21.0549 7.23909 21.0549 7.14578V7.14578C21.0549 4.34187 18.7819 2.06885 15.978 2.06885C13.174 2.06885 10.901 4.34187 10.901 7.14578V7.14578C10.901 7.23975 10.8292 7.319 10.7357 7.32854C8.07749 7.59955 6.0033 9.84495 6.0033 12.5748C6.0033 13.3904 6.18848 14.1628 6.51904 14.8522C6.60562 15.0327 6.56027 15.2512 6.40884 15.3822C5.28693 16.3531 4.57715 17.7874 4.57715 19.3876C4.57715 22.3118 6.94775 24.6824 9.87201 24.6824H22.0997C25.024 24.6824 27.3946 22.3118 27.3946 19.3876C27.3946 17.7874 26.6848 16.3531 25.5629 15.3822C25.4115 15.2512 25.3662 15.0327 25.4528 14.8522C25.7833 14.1628 25.9684 13.3904 25.9684 12.5748C25.9684 9.83918 23.8856 7.59005 21.2192 7.32684Z",
  fill: "url(#paint11_radial_28327_7673)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.2192 7.32684C21.1263 7.31768 21.0549 7.23909 21.0549 7.14578V7.14578C21.0549 4.34187 18.7819 2.06885 15.978 2.06885C13.174 2.06885 10.901 4.34187 10.901 7.14578V7.14578C10.901 7.23975 10.8292 7.319 10.7357 7.32854C8.07749 7.59955 6.0033 9.84495 6.0033 12.5748C6.0033 13.3904 6.18848 14.1628 6.51904 14.8522C6.60562 15.0327 6.56027 15.2512 6.40884 15.3822C5.28693 16.3531 4.57715 17.7874 4.57715 19.3876C4.57715 22.3118 6.94775 24.6824 9.87201 24.6824H22.0997C25.024 24.6824 27.3946 22.3118 27.3946 19.3876C27.3946 17.7874 26.6848 16.3531 25.5629 15.3822C25.4115 15.2512 25.3662 15.0327 25.4528 14.8522C25.7833 14.1628 25.9684 13.3904 25.9684 12.5748C25.9684 9.83918 23.8856 7.59005 21.2192 7.32684Z",
  fill: "url(#paint12_radial_28327_7673)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.2192 7.32684C21.1263 7.31768 21.0549 7.23909 21.0549 7.14578V7.14578C21.0549 4.34187 18.7819 2.06885 15.978 2.06885C13.174 2.06885 10.901 4.34187 10.901 7.14578V7.14578C10.901 7.23975 10.8292 7.319 10.7357 7.32854C8.07749 7.59955 6.0033 9.84495 6.0033 12.5748C6.0033 13.3904 6.18848 14.1628 6.51904 14.8522C6.60562 15.0327 6.56027 15.2512 6.40884 15.3822C5.28693 16.3531 4.57715 17.7874 4.57715 19.3876C4.57715 22.3118 6.94775 24.6824 9.87201 24.6824H22.0997C25.024 24.6824 27.3946 22.3118 27.3946 19.3876C27.3946 17.7874 26.6848 16.3531 25.5629 15.3822C25.4115 15.2512 25.3662 15.0327 25.4528 14.8522C25.7833 14.1628 25.9684 13.3904 25.9684 12.5748C25.9684 9.83918 23.8856 7.59005 21.2192 7.32684Z",
  fill: "url(#paint13_radial_28327_7673)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.2192 7.32684C21.1263 7.31768 21.0549 7.23909 21.0549 7.14578V7.14578C21.0549 4.34187 18.7819 2.06885 15.978 2.06885C13.174 2.06885 10.901 4.34187 10.901 7.14578V7.14578C10.901 7.23975 10.8292 7.319 10.7357 7.32854C8.07749 7.59955 6.0033 9.84495 6.0033 12.5748C6.0033 13.3904 6.18848 14.1628 6.51904 14.8522C6.60562 15.0327 6.56027 15.2512 6.40884 15.3822C5.28693 16.3531 4.57715 17.7874 4.57715 19.3876C4.57715 22.3118 6.94775 24.6824 9.87201 24.6824H22.0997C25.024 24.6824 27.3946 22.3118 27.3946 19.3876C27.3946 17.7874 26.6848 16.3531 25.5629 15.3822C25.4115 15.2512 25.3662 15.0327 25.4528 14.8522C25.7833 14.1628 25.9684 13.3904 25.9684 12.5748C25.9684 9.83918 23.8856 7.59005 21.2192 7.32684Z",
  fill: "url(#paint14_linear_28327_7673)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.2192 7.32684C21.1263 7.31768 21.0549 7.23909 21.0549 7.14578V7.14578C21.0549 4.34187 18.7819 2.06885 15.978 2.06885C13.174 2.06885 10.901 4.34187 10.901 7.14578V7.14578C10.901 7.23975 10.8292 7.319 10.7357 7.32854C8.07749 7.59955 6.0033 9.84495 6.0033 12.5748C6.0033 13.3904 6.18848 14.1628 6.51904 14.8522C6.60562 15.0327 6.56027 15.2512 6.40884 15.3822C5.28693 16.3531 4.57715 17.7874 4.57715 19.3876C4.57715 22.3118 6.94775 24.6824 9.87201 24.6824H22.0997C25.024 24.6824 27.3946 22.3118 27.3946 19.3876C27.3946 17.7874 26.6848 16.3531 25.5629 15.3822C25.4115 15.2512 25.3662 15.0327 25.4528 14.8522C25.7833 14.1628 25.9684 13.3904 25.9684 12.5748C25.9684 9.83918 23.8856 7.59005 21.2192 7.32684Z",
  fill: "url(#paint15_radial_28327_7673)",
  fillOpacity: 0.75
}));

var _ref9 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_f_28327_7673)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 16.2808,
  y: 24.958,
  width: 1.33447,
  height: 4.89396,
  fill: "url(#paint16_linear_28327_7673)"
}));

var _ref10 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_f_28327_7673)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 0.744866,
  height: 4.89396,
  transform: "matrix(-1 0 0 1 16.2808 24.958)",
  fill: "url(#paint17_linear_28327_7673)"
}));

var _ref11 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter3_f_28327_7673)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 22.6837,
  cy: 11.8856,
  rx: 2.67589,
  ry: 2.47579,
  transform: "rotate(-12.4803 22.6837 11.8856)",
  fill: "url(#paint18_radial_28327_7673)"
}));

var _ref12 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter4_f_28327_7673)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 17.5648,
  cy: 5.90113,
  rx: 2.56855,
  ry: 2.01524,
  transform: "rotate(-7.46292 17.5648 5.90113)",
  fill: "url(#paint19_radial_28327_7673)"
}));

var _ref13 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter5_f_28327_7673)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 23.6994,
  cy: 18.7751,
  rx: 2.67589,
  ry: 2.47579,
  transform: "rotate(-12.4803 23.6994 18.7751)",
  fill: "url(#paint20_radial_28327_7673)"
}));

var _ref14 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter6_f_28327_7673)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.38281 15.583H20.2578C21.2578 15.5674 23.5266 15.4486 24.6016 15.0986",
  stroke: "url(#paint21_linear_28327_7673)",
  strokeWidth: 0.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref15 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter7_f_28327_7673)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.1953 7.58301C11.8724 7.99967 13.7703 8.83301 15.9453 8.83301C18.1203 8.83301 20.2109 7.99967 20.8047 7.58301",
  stroke: "url(#paint22_linear_28327_7673)",
  strokeWidth: 0.4,
  strokeLinecap: "round"
}));

var _ref16 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter8_f_28327_7673)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.3804 3.12988C13.5158 3.4528 11.7554 4.48301 11.7554 7.58301",
  stroke: "url(#paint23_linear_28327_7673)",
  strokeWidth: 0.5,
  strokeLinecap: "round"
}));

var _ref17 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter9_f_28327_7673)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.87716 8.19751C9.06607 8.42925 7.34909 9.41731 6.96987 11.5156C6.67233 13.1622 7.29642 14.9602 7.6967 15.371",
  stroke: "url(#paint24_linear_28327_7673)",
  strokeWidth: 0.5,
  strokeLinecap: "round"
}));

var _ref18 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter10_f_28327_7673)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.63354 15.2446C6.89619 15.6344 5.43413 17.008 5.48468 19.3844C5.53522 21.7608 7.31752 23.1344 8.20235 23.5241",
  stroke: "url(#paint25_linear_28327_7673)",
  strokeWidth: 0.5,
  strokeLinecap: "round"
}));

var _ref19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_i_28327_7673",
  x: 4.57715,
  y: 2.06885,
  width: 23.3174,
  height: 22.6135,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.619608 0 0 0 0 0.72549 0 0 0 0 0.639216 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_28327_7673"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_f_28327_7673",
  x: 15.2808,
  y: 23.958,
  width: 3.33447,
  height: 6.89404,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  result: "effect1_foregroundBlur_28327_7673"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_f_28327_7673",
  x: 14.5359,
  y: 23.958,
  width: 2.74487,
  height: 6.89404,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  result: "effect1_foregroundBlur_28327_7673"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter3_f_28327_7673",
  x: 18.0163,
  y: 7.39966,
  width: 9.33484,
  height: 8.97217,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1,
  result: "effect1_foregroundBlur_28327_7673"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter4_f_28327_7673",
  x: 13.0043,
  y: 1.875,
  width: 9.12085,
  height: 8.05225,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1,
  result: "effect1_foregroundBlur_28327_7673"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter5_f_28327_7673",
  x: 19.032,
  y: 14.2891,
  width: 9.33484,
  height: 8.97217,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1,
  result: "effect1_foregroundBlur_28327_7673"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter6_f_28327_7673",
  x: 8.48281,
  y: 14.1986,
  width: 17.0188,
  height: 2.28437,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.325,
  result: "effect1_foregroundBlur_28327_7673"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter7_f_28327_7673",
  x: 10.5453,
  y: 6.93306,
  width: 10.9094,
  height: 2.5499,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.225,
  result: "effect1_foregroundBlur_28327_7673"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter8_f_28327_7673",
  x: 10.5054,
  y: 1.87988,
  width: 5.12506,
  height: 6.95312,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  result: "effect1_foregroundBlur_28327_7673"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter9_f_28327_7673",
  x: 5.39209,
  y: 6.69751,
  width: 5.98511,
  height: 10.1733,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.625,
  result: "effect1_foregroundBlur_28327_7673"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter10_f_28327_7673",
  x: 3.9834,
  y: 13.7446,
  width: 5.71899,
  height: 11.2795,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.625,
  result: "effect1_foregroundBlur_28327_7673"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_28327_7673",
  x1: 13.0977,
  y1: 28.3025,
  x2: 15.5359,
  y2: 28.3025,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#908181"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#908181",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_28327_7673",
  x1: 13.6985,
  y1: 27.7322,
  x2: 14.3954,
  y2: 27.7322,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5B363A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5B363A",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_28327_7673",
  x1: 15.9859,
  y1: 30.1327,
  x2: 15.9859,
  y2: 29.734,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6A2F5B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6A2F5B",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_28327_7673",
  x1: 18.7891,
  y1: 26.708,
  x2: 17.8984,
  y2: 26.708,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6D5C5C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6D5C5C",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint4_radial_28327_7673",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(17.5547 24.6768) rotate(89.5848) scale(2.15631 0.79708)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.406931,
  stopColor: "#4D2D31"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4D2D31",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint5_radial_28327_7673",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(23.8828 15.5829) rotate(180) scale(16.5625 16.7118)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7CBE4D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#549756"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint6_radial_28327_7673",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(6.94531 23.2704) rotate(-24.0013) scale(9.37292 10.4352)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#438154"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#438154",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint7_radial_28327_7673",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(5.32031 13.3756) scale(9 6.69653)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#438154"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#438154",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint8_radial_28327_7673",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(10.5703 4.58291) rotate(25.622) scale(6.79298 5.20183)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#438154"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#438154",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint9_radial_28327_7673",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(9.97656 7.23916) rotate(159.814) scale(2.26406 0.936078)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#438154"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#438154",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint10_radial_28327_7673",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(25.8828 12.1454) rotate(168.972) scale(6.43126 6.68871)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#81CB44"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#81CB44",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint11_radial_28327_7673",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(28.5703 19.5829) rotate(-167.6) scale(9.02297 9.38417)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#81CB44"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#81CB44",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint12_radial_28327_7673",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(23.0078 3.64541) rotate(156.009) scale(7.68592 8.09726)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#81CB44"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#81CB44",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint13_radial_28327_7673",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(8.32031 26.9579) rotate(-6.43265) scale(12.8308 6.7718)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5A6F6C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5A6F6C",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint14_linear_28327_7673",
  x1: 11.6939,
  y1: 25.3057,
  x2: 11.8208,
  y2: 23.3594,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7A7397"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7A7397",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint15_radial_28327_7673",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(13.4709 14.1358) scale(7.78511 3.07216)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5B8F67"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.83377,
  stopColor: "#5B8F67",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint16_linear_28327_7673",
  x1: 16.948,
  y1: 22.1924,
  x2: 16.948,
  y2: 29.852,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7F5B60",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7F5B60"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint17_linear_28327_7673",
  x1: 0.372433,
  y1: -1.04404,
  x2: 0.372433,
  y2: 4.89396,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#683B4B",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#683B4B"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint18_radial_28327_7673",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(24.2511 11.4761) rotate(159.193) scale(4.53937 3.15303)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A0E271"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A0E271",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint19_radial_28327_7673",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(19.9923 5.45704) rotate(163.38) scale(4.5183 1.94024)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A0E271"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A0E271",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint20_radial_28327_7673",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(25.2669 18.3655) rotate(159.193) scale(4.53937 3.15303)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A0E271"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A0E271",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint21_linear_28327_7673",
  x1: 25.6953,
  y1: 15.583,
  x2: 9.38281,
  y2: 15.583,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.091954,
  stopColor: "#9DDB71"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6CA663",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint22_linear_28327_7673",
  x1: 21.1101,
  y1: 8.83305,
  x2: 8.82031,
  y2: 8.83305,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9DDB71"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.505208,
  stopColor: "#6CA663",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6CA663"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint23_linear_28327_7673",
  x1: 12.5317,
  y1: 7.43905,
  x2: 16.8927,
  y2: -0.492836,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8FB48E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8FB48E",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint24_linear_28327_7673",
  x1: 7.77492,
  y1: 15.1391,
  x2: 15.8414,
  y2: 4.78185,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8FB48E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8FB48E",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint25_linear_28327_7673",
  x1: 6.38281,
  y1: 16.5831,
  x2: 3.59811,
  y2: 23.3465,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8FB48E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8FB48E",
  stopOpacity: 0
})));

function SvgDeciduousTree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeciduousTree);
export default __webpack_public_path__ + "static/media/deciduous-tree.3cdd7774.svg";
export { ForwardRef as ReactComponent };